import { createFileRoute, redirect } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

import { SettingsSearchSchema } from "@/pages/settings/route";

/** Keeps older Slack OAuth redirect URLs working until env is updated. */
export const Route = createFileRoute("/settings/integrations/slack-redirect")({
    validateSearch: zodValidator(SettingsSearchSchema),
    beforeLoad: ({ search }) => {
        throw redirect({
            to: "/settings",
            search,
        });
    },
});
